import { Component, OnInit, Input } from '@angular/core';
import { OptionsserviceService, LoansService, StorageService, OperationsService, DataService } from '../../_services/index';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-contractoffer',
  templateUrl: './contractoffer.component.html',
  styleUrls: ['./contractoffer.component.css']
})
export class ContractofferComponent implements OnInit {

  @Input('offer') offer: any;
  @Input('loan') loan: any;
  currentUser: any;
  @Input('parentRouteId') parentRouteId: any;
  @Input('where') where = '1';
  sub: any;
  loading = false;
  editorConfig = {
    editable: true,
    spellcheck: false,
    height: '350px',
    minHeight: '350px',
    placeholder: 'Enter your text here',
    translate: 'no',
    width: "100%",
    minWidth: "100%"
  };
  sendform = {
    'REQUEST_ID': '',
    'TIME_TO_SEND': ''
  };

  printing = false;
  contractSending = false;
  sendingContract = false;
  constructor(public toastr: ToastrService, public route: ActivatedRoute, public storageService: StorageService,
    public optionsService: OptionsserviceService, public loansService: LoansService,
    public operationsService: OperationsService, public dataService: DataService) {

  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }
  ngOnInit() {
    this.currentUser = this.storageService.read<any>('currentUser');

    if (this.where == '1') {
      this.sub = this.route.parent.params.subscribe(params => {
        this.parentRouteId = +params["id"];
        this.loansService.getLoanOffer(this.currentUser.token, this.parentRouteId)
          .subscribe(data => {
            this.offer = data.offer;
            this.sendform.REQUEST_ID = this.offer.REQUEST_ID;
            this.sendform.TIME_TO_SEND = '1';


            this.sendform.REQUEST_ID = this.offer.REQUEST_ID;
          });
      });
    } 
    else { 
      console.log(this.offer, 'contract offer')
      this.sendform.REQUEST_ID = this.offer.REQUEST_ID;
      this.sendform.TIME_TO_SEND = '1';  
    }
  }
  sendContract(value, valid) {
    this.loading = true;
    this.loansService.sendContract(this.currentUser.token, value, this.offer)
      .subscribe(data => {
        this.loading = false;
        this.showSuccess(data.message);
      });
  }
  modifyOffertemplate(){
    this.dataService.modifyOfferTemplate.emit({OFFER_LETTER: this.offer.template, loan_product_id : this.offer.LOAN_PRODUCT_ID});
  }
  saveOL(value, valid) {
    this.loading = true;
    this.loansService.saveOLSettings(this.currentUser.token, value)
      .subscribe(data => {
        this.loading = false;
        this.showSuccess(data.message);
      });
  }
  printTheOfferLetter() {
    this.printing = true;
    this.currentUser = this.storageService.read<any>('currentUser');

    this.sub = this.route.parent.params.subscribe(params => {

      if (this.where == '1') {

        this.parentRouteId = +params["id"];
        this.loansService.printTheOfferLetter(this.currentUser.token, this.parentRouteId, this.offer)
          .subscribe(data => {
            this.printing = false;
            window.open(data.link);
          });
      } else {
        this.loansService.printTheOfferLetter(this.currentUser.token, this.parentRouteId, this.offer)
          .subscribe(data => {
            this.printing = false;
            window.open(data.link);
          });
      }
    });
  }
}
